import { useParams } from "react-router-dom";
import { accountText } from "./_accountText";
export default function Wishlist(){const {lang}=useParams(); const x=accountText(lang); return <div><h1 className="text-2xl font-black">{x.wishlist}</h1><p className="mt-2 text-slate-600">{lang==="zh"?"你收藏的商品会显示在这里。":"Saved products appear here."}</p></div>;}
